<template>
  <el-row :gutter="20" class="main_block">
    <div class="mianContent">
      <div class="result">
        <div class="white">
          <div class="successIcon">
            <img src="@/assets/images/realName/success.png" alt="">
          </div>
          <div class="des">
            认证已完成
          </div>
          <div class="info">
            <div class="table">
              <dl>
                <dt>单位名称</dt>
                <dd>{{ realInfo.name }}</dd>
              </dl>
              <dl>
                <dt>组织类型</dt>
                <dd>{{ realInfo.type }}</dd>
              </dl>
              <dl>
                <dt>统一社会信用代码</dt>
                <dd>{{ realInfo.uscc }}</dd>
              </dl>
              <dl>
                <dt>法定代表人</dt>
                <dd>{{ realInfo.legal }}</dd>
              </dl>
              <dl>
                <dt>营业执照</dt>
                <dd>
                  <!-- <img :src="realInfo.businessUrl" alt=""> -->
                  <el-image
                      style="width: 100px;"
                      :src="realInfo.businessUrl"
                      :preview-src-list="[realInfo.businessUrl]">
                  </el-image>
                </dd>
              </dl>
            </div>
          </div>
        </div>
        <div class="submit">
          <span class="primary" @click="quit">完成认证</span>
        </div>
      </div>
    </div>
  </el-row>
</template>

<script>
import {identification} from "@http/user_center/userInfo";

export default {
  data() {
    return {
      isChild: false,
      realInfo: {
        name: '',
        legal: '',
        uscc: '',
        type: '',
        businessUrl: '',
      },
    };
  },

  components: {},

  computed: {},

  created() {
    this.init();
  },

  mounted() {
    this.$TsaWebTrace.post({
      data: {
        "eventId": 35031,
      },
    });
  },

  methods: {
    async init() {
      try {
        let res = await identification();
        if (res.authenticationStatus == 10) {
          this.realInfo = res.enterprise;
          this.realInfo.type = "法人"
        } else {
          setTimeout(() => {
            this.$router.replace({
              path: '/userCenter/AuthenticationName'
            })
          }, 3000);
        }
      } catch (error) {
        setTimeout(() => {
          this.$router.replace({
            path: '/userCenter/AuthenticationName'
          })
        }, 3000);
      }

    },
    quit() {
      if (this.$getlocalStorage("queryData")?.from == 'lawcase') {
        this.$store.dispatch('userInfo/setLawyerInfo', {})
        zhuge.track('律师咨询_实名认证成功', {'端': 'PC'}, () => {
          if (this.$getlocalStorage("queryData")?.to) {
            window.location.href = `${process.env.VUE_APP_LAWCASE}/userCenter/authentication?to=${this.$getlocalStorage("queryData").to}&randomKey=${this.$getlocalStorage("queryData").randomKey || ''}`
          } else {
            window.location.href = `${process.env.VUE_APP_LAWCASE}/userCenter/authentication`
          }
        })
        return;
      }
      if (window.opener) {
        window.opener = null;
        window.open('', '_self');
        window.close();
      } else {
        this.$router.replace({
          path: '/userCenter/AuthenticationName'
        })
      }
    }
  },
};
</script>
<style lang="less" scoped>
.wrap {
  padding-top: 46Px;
}

.result {
  .white {
    background: #fff;
    padding: 40px 34px;
    margin-top: 40px;

    .successIcon {
      text-align: center;

      img {
        width: 120px;
      }
    }

    .des {
      text-align: center;
      color: #333;
      font-size: 16px;
      line-height: 30px;
      margin-bottom: 30px;
    }
  }
}

.table {
  width: 100%;
  margin-top: 29px;
  box-sizing: border-box;
  padding: 10px 20%;
  background: #fafafa;
  border: 1px solid #e1e6eb;
}

.table dl {
  overflow: hidden;
  border-bottom: 1px dashed #e1e6eb;
  padding: 20px 0 20px;
  font-size: 14px;
  color: #333;
}

.table dl:last-child {
  border: none;
}

.table dt {
  float: left;
}

.table dd {
  float: right;
  max-width: 310px;

  img {
    max-width: 100%;
  }
}

.submit {
  text-align: center;

  span {
    display: inline-block;
    width: 130px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    color: #10A0E9;
    font-size: 16px;
    border-radius: 5px;
    border: 1px solid #10A0E9;
    cursor: pointer;
  }

  .primary {
    background: #10A0E9;
    color: #fff;
    margin-bottom: 20px;
    margin-right: 50px;
    opacity: .7;

    &:hover {
      opacity: 1;
    }
  }
}
</style>
